
import {of as observableOf,  Observable, Subscription } from 'rxjs';
import { AfterViewInit, Component, Input, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, NgForm, Validators } from '@angular/forms';
import { PackageBillingService } from './package-billing.service';
import * as _ from 'lodash';
import { PackageBillingModel } from './package-billing.model';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { B2CAdminComponent } from '../../b2c-admin.component';
import { ClinicsService } from '../../../../clinics/clinics.service';
import { PasswordService } from '../../../../auth/forgot-password/password.service';
import { AuthService } from '../../../../core/auth.service';
import { CoreService } from '../../../../core/core.service';
import { BaseService } from '../../../../shared/base.service';
import { AppService } from '../../../../app.service';
import { UsersService } from '../../../../users/users.service';
import { HomeService } from '../../../home.service';
import { MaintenanceService } from '../../../../maintenance/maintenance.service';
import { SecureApi } from '../../../../core/secure.api';
import { MaintenanceComponent } from '../../../../maintenance/maintenance.component';

@Component({
    selector: 'package-billing-component',
    templateUrl: './package-billing.component.html',
    styleUrls: ['./package-billing.component.scss'],
    providers: [PackageBillingService, ClinicsService, PasswordService ,BaseService]
})

export class PackageBillingComponent extends B2CAdminComponent implements OnInit, AfterViewInit {
    helpClinicProfile: any;
    @Input() isHome = false;
    @Input() filters;
    @Input() filterParams;
    @Input() url = '/admin/package-billing';
    roles: Object[] = [];
    clinics: Object[] = [];
    userRoleId: number;
    billing: any;

    // define what table columns to display [column key, label, css class]
    readonly tableColumns = [
        ['patient_id',      'Patient Id',   'col-xs-2'],
        ['article_type',    'Package',      'col-xs-5'],
        ['created_at',      'Billing Date', 'col-xs-5'],
    ];

    constructor(public authService: AuthService,
                public coreService: CoreService,
                public router: Router,
                public translate: TranslateService,
                public fb: FormBuilder,
                public baseService: BaseService,
                public usersService: UsersService,
                public appService: AppService,
                public homeService: HomeService,
                public clinicService: ClinicsService,
                public maintenanceService: MaintenanceService,
                public secureApi: SecureApi,
                public maintenanceComponent: MaintenanceComponent,
                public route: ActivatedRoute,
                public packageBillingService: PackageBillingService) {
        super(authService, coreService, router, translate,fb,  baseService, appService, usersService, homeService, clinicService , maintenanceService, secureApi, maintenanceComponent );
    }

    ngOnInit() {
        super.ngOnInit();

        this.searchInfo = new PackageBillingModel();
        this.sortedColumn = 'code';
        this.url = 'b2c-patients/package-billing';
        this.token = this.authService.user['token'];

        // sort
        this.initSorting();

        if(!this.isHome){
            return this.getItems();
        }
    }

    ngAfterViewInit() {
    }

    /**
     * @param {SimpleChanges} changes
     */
    ngOnChanges(changes: SimpleChanges) {
        if (changes['filters'] && this.filters) {
            return this.getItems();
        }
    }

    get isClinicView() {
        return this.clinicId;
    }

    getItems() {
        this.initPageSize(this.isHome);
        this.packageBillingService.getAll(this.filters)
            .subscribe(data => {
                this.setData(data);
            });
    }

    setData(data: any): void {
        this.billing = data['total'] || [];
        this.items = data['data'] || [];
        if (data.filters != null) {
            this.filters = data.filters;
            this.asyncFilters = observableOf(data.filters);
        }
        // if packageBilling are empty, hide the page numbers below the packageBilling list to prevent page redirection
        this.paginationHidden = this.billing.length === 0;
        this.isLoading = false;
    }

    navigateRoute() {
        this.router.navigate(['./'], {
            relativeTo: this.route
        });
    }

    exportData(data = null){
        window.onbeforeunload = function() {
            // will handle later
        };

        const billingExportForm = <HTMLFormElement>document.getElementById('frmExport');
        this.token = this.authService.user['token'];
        billingExportForm.action = billingExportForm.action + '?token=' + this.token;

        //Language
        billingExportForm.action += '&lang=' + this.translate.currentLang;

        let action = this.filters ? '&' + this.filters : '';
        if(data && data?.length){
            for(let name in data){
                action += `&${name}=${data[name]}`;
            }
        }
        billingExportForm.action += action;
        billingExportForm.submit();
    }


    sortBilling(column) {
        if (column === 'created_at') {
            column = 'created_at_sort';
        }

        this.sort(column, false, this.sortUsingApi);
    }

}
